import { Typography } from "@/components/atoms";
import { clsx } from "@/utils";

interface AnnouncementBarProps {
  lead: string;
  body: string;
  /**
   * Omitted while the "learn more" page is unpublished — the message still stands without it, so an
   * unset URL drops the LINK rather than hiding the banner.
   */
  url?: string;
  /** Layout the surrounding shell needs, e.g. tracking the operator sidebar. */
  innerClassName?: string;
}

/**
 * The purple announcement strip. Presentation only — it never decides whether to show, which phase,
 * or which audience. Both surfaces (operator dashboard, client portal) render through it so a change
 * to the bar cannot land on one and miss the other.
 */
export const AnnouncementBar = ({ lead, body, url, innerClassName }: AnnouncementBarProps) => (
  <div className="relative top-0 z-40 bg-vivid-purple-dark px-5 py-2 text-white transition-all duration-200">
    <div
      className={clsx(
        "mx-auto flex max-w-screen-2xl flex-row flex-wrap items-center justify-center gap-x-2 gap-y-1 text-center transition-all duration-200",
        innerClassName
      )}
    >
      <Typography variant="action" className="text-white">
        ✨ <span className="font-semibold">{lead}</span> {body} ✨
      </Typography>
      {url && (
        <a href={url} target="_blank" rel="noopener noreferrer" className="flex-shrink-0 whitespace-nowrap text-white underline">
          <Typography variant="action" className="text-white">
            Click here to learn more →
          </Typography>
        </a>
      )}
    </div>
  </div>
);
